import { render, staticRenderFns } from "./CenterPieChart.vue?vue&type=template&id=58880637&scoped=true&"
import script from "./CenterPieChart.vue?vue&type=script&lang=js&"
export * from "./CenterPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CenterPieChart.vue?vue&type=style&index=0&id=58880637&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58880637",
  null
  
)

export default component.exports